export default function destroyToastSlice(index) {
	return (dispatch) => {
		dispatch({
			type: 'DESTROY_TOAST_SLICE',
			payload: {index},
		});
	};
}